namespace $.$$ {
	export class $shm_hitalama_file_attach extends $.$shm_hitalama_file_attach {
		file_drag_has_files( event: DragEvent ) {
			const transfer = event.dataTransfer
			return Boolean( transfer && ( Array.from( transfer.types ?? [] ).includes( 'Files' )
				|| Array.from( transfer.files ?? [] ).length
				|| Array.from( transfer.items ?? [] ).some( item => item.kind === 'file' ) ) )
		}

		file_dragover( event: DragEvent ) {
			if( !this.file_drag_has_files( event ) ) return
			event.preventDefault()
			event.stopPropagation()
			if( event.dataTransfer ) event.dataTransfer.dropEffect = 'copy'
		}

		@ $mol_action
		file_drop( event: DragEvent ) {
			if( !this.file_drag_has_files( event ) ) return
			if( ( event as DragEvent & { shm_file_drop_handled?: boolean } ).shm_file_drop_handled ) {
				event.stopPropagation()
				return
			}
			event.preventDefault()
			event.stopPropagation()
			const files = Array.from( event.dataTransfer?.files ?? [] )
			if( files.length ) this.files( files )
		}
		
		filename(): string {
			const file = this.files()[0]
			if( file ) return file.name
			const value = this.value()
			if( !value ) return ''
			return $giper_baza_glob.Pawn( new $giper_baza_link( value ), $shm_hitalama_file ).title()
		}

		delete_visible() {
			return this.filename() ? super.delete_visible() : []
		}

		@ $mol_action
		file_delete( next?: Event ) {
			if( next === undefined ) return null
			this.value( '' )
			this.files( [] )
			return next
		}
		
	}
}
